// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__tErlC","paramInput":"JobSimulator_paramInput__1FVLJ","input":"JobSimulator_input__wb6rj"};